import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Terms() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 py-12">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-rose-500/10 border border-rose-500/30 text-rose-300 text-xs font-semibold uppercase tracking-widest">
          Légal
        </div>
        <h1 className="mt-4 font-display font-extrabold text-4xl sm:text-5xl">Conditions Générales d'Utilisation</h1>
        <p className="mt-2 text-slate-500 text-sm">Dernière mise à jour : février 2026</p>

        <div className="mt-10 space-y-8 text-slate-300 leading-relaxed">
          <section>
            <h2 className="font-display text-xl font-bold text-white">1. Objet</h2>
            <p className="mt-2">JOTALY (« la Plateforme ») est un service en ligne édité depuis Dakar, Sénégal, qui met en relation des vendeurs et des acheteurs autour d'enchères en direct.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">2. Compte utilisateur</h2>
            <p className="mt-2">Toute personne majeure peut créer un compte gratuit. Vous vous engagez à fournir des informations exactes et à ne pas partager vos identifiants. Les comptes vendeurs sont soumis à validation par l'équipe.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">3. Enchères</h2>
            <p className="mt-2">Chaque enchère est un engagement ferme. Le meilleur enchérisseur à la fin du timer remporte le produit et dispose de 10 minutes pour effectuer le paiement via Wave ou Orange Money. Un défaut de paiement peut entraîner une suspension du compte.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">4. Paiement et livraison</h2>
            <p className="mt-2">Les paiements sont effectués directement entre acheteurs et vendeurs via Wave / Orange Money. La Plateforme ne détient pas les fonds. La livraison est organisée entre les parties. En cas de litige, l'équipe peut intervenir en médiation.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">5. Obligations des vendeurs</h2>
            <p className="mt-2">Les vendeurs doivent proposer des produits authentiques, conformes à leur description, et livrer dans un délai raisonnable après confirmation du paiement.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">6. Interdictions</h2>
            <p className="mt-2">Les vendeurs peuvent proposer tout type de produit légal, neuf ou d'occasion. Sont interdits : produits illégaux, contrefaçons, contenus offensants, harcèlement dans le chat, fraude aux enchères (comptes multiples), et tout comportement contraire à la loi sénégalaise.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">7. Responsabilité</h2>
            <p className="mt-2">JOTALY agit comme intermédiaire technique. La Plateforme n'est pas responsable de la qualité des produits, des retards de livraison ou des litiges commerciaux, mais s'engage à modérer et sanctionner les abus.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">8. Droit applicable</h2>
            <p className="mt-2">Les présentes CGU sont soumises au droit sénégalais. Tout litige non résolu à l'amiable relèvera de la compétence exclusive des tribunaux de Dakar.</p>
          </section>
          <section>
            <h2 className="font-display text-xl font-bold text-white">9. Contact</h2>
            <p className="mt-2">Pour toute question : <a href="mailto:contactjotaly@gmail.com" className="text-rose-400 hover:underline">contactjotaly@gmail.com</a>.</p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
